module.exports = __webpack_public_path__ + "img/upload-white.cb6109d6.svg";